export type NetworkCenterMarkProps = {
  x: number;
  y: number;
};

// Rendered after the center core so the brand remains visible in SVG paint
// order. The interaction target remains a separate final layer.
export function NetworkCenterMark({ x, y }: NetworkCenterMarkProps) {
  return (
    <>
      <image
        href="/brand/ga-mark-light.svg"
        x={x - 6.5}
        y={y - 6.5}
        width="13"
        height="13"
        className="dark:hidden select-none pointer-events-none"
      />
      <image
        href="/brand/ga-mark-dark.svg"
        x={x - 6.5}
        y={y - 6.5}
        width="13"
        height="13"
        className="hidden dark:block select-none pointer-events-none"
      />
    </>
  );
}
